import styled from '@emotion/styled'

import { breakpoints, palette, Small, spacing, typography } from 'main/ui'

const padding = spacing.majorScale(2)
const ratingGap = spacing.minorScale(3)

export const Container = styled.div`
  background-color: ${palette.whiteDove};
  columns: 1 auto;
  column-gap: ${spacing.majorScale(1)}px;
  padding-bottom: ${padding - ratingGap}px;
  padding-left: ${padding}px;
  padding-right: ${padding}px;
  padding-top: ${padding}px;

  @media (min-width: ${breakpoints.lg}px) {
    columns: 2 auto;
  }
`

export const RatingContainer = styled.div`
  margin-bottom: ${ratingGap}px;
`

export const RatingLabel = styled(Small)`
  font-weight: ${typography.fontWeight.bold};
  margin-left: ${spacing.majorScale(1)}px;
`
